import { NavLink, useLocation } from 'react-router-dom'
import { useAuth } from '@clerk/clerk-react'

export default function Sidebar() {
  const { signOut, user } = useAuth()
  const location = useLocation()
  
  // Debug log
  console.log('Sidebar component loaded!')

  const menuItems = [
    { path: '/', icon: '📊', label: 'Dashboard' },
    { path: '/orders', icon: '📦', label: 'Orders' },
    { path: '/sales', icon: '💰', label: 'Sales' },
    { path: '/logs', icon: '📋', label: 'Logs' },
    { path: '/settings', icon: '⚙️', label: 'Settings' },
  ]

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname === '/dashboard'
    }
    return location.pathname === path
  }

  return (
    <nav
      style={{
        width: '260px',
        background: 'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)',
        color: 'white',
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '2px 0 10px rgba(0,0,0,0.1)',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '2rem 1.5rem',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
        }}
      >
        <h2
          style={{
            margin: 0,
            color: '#fff',
            fontSize: '1.5rem',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          <span style={{ fontSize: '2rem' }}>🚀</span>
          Obayito
        </h2>
        <p
          style={{
            margin: '0.5rem 0 0 0',
            fontSize: '0.875rem',
            color: '#94a3b8',
          }}
        >
          Admin Dashboard
        </p>
      </div>

      {/* Menu Items */}
      <div style={{ flex: 1, padding: '1.5rem 1rem' }}>
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.875rem 1rem',
              color: isActive(item.path) ? '#fff' : '#94a3b8',
              textDecoration: 'none',
              borderRadius: '8px',
              marginBottom: '0.5rem',
              background: isActive(item.path)
                ? 'linear-gradient(90deg, #3b82f6 0%, #2563eb 100%)'
                : 'transparent',
              fontWeight: isActive(item.path) ? '600' : '400',
              transition: 'all 0.2s ease',
              position: 'relative',
              overflow: 'hidden',
            }}
            onMouseEnter={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)'
                e.currentTarget.style.color = '#fff'
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.background = 'transparent'
                e.currentTarget.style.color = '#94a3b8'
              }
            }}
          >
            <span style={{ fontSize: '1.25rem' }}>{item.icon}</span>
            <span style={{ fontSize: '0.95rem' }}>{item.label}</span>
            {isActive(item.path) && (
              <span
                style={{
                  position: 'absolute',
                  right: '0.5rem',
                  width: '4px',
                  height: '20px',
                  background: '#fff',
                  borderRadius: '2px',
                }}
              />
            )}
          </NavLink>
        ))}
      </div>

      {/* User Section */}
      <div
        style={{
          borderTop: '1px solid rgba(255,255,255,0.1)',
          padding: '1.5rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem',
            padding: '0.75rem',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: '8px',
          }}
        >
          <div
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.25rem',
              fontWeight: 'bold',
            }}
          >
            {user?.firstName?.charAt(0) || 'U'}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p
              style={{
                margin: 0,
                fontSize: '0.95rem',
                fontWeight: '600',
                color: '#fff',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {user?.firstName || 'User'}
            </p>
            <p
              style={{
                margin: 0,
                fontSize: '0.75rem',
                color: '#94a3b8',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              Administrator
            </p>
          </div>
        </div>
        <button
          onClick={() => signOut()}
          style={{
            width: '100%',
            padding: '0.75rem',
            background: 'rgba(239, 68, 68, 0.1)',
            color: '#ef4444',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#ef4444'
            e.currentTarget.style.color = '#fff'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)'
            e.currentTarget.style.color = '#ef4444'
          }}
        >
          <span>🚪</span>
          Sign Out
        </button>
      </div>
    </nav>
  )
}
